import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

export const Modal = styled.div<{ open: boolean; position: [number, number] }>`
  z-index: 1000;
  position: fixed;
  /* overflow: hidden; */
  top: 0;
  left: 0;
`;

export const Wrapper = styled.div<{ open: boolean; fullyOpen: boolean; shrinkHeight: boolean }>`
  position: fixed;
  transition: width, height 0s linear;
  transition-delay: ${(props) => (props.open ? '0s' : '0.4s')};
  width: ${(props) => (props.open ? '100vw' : 0)};
  height: ${(props) => (props.open ? '100%' : 0)};
  top: env(safe-area-inset-top, 0);
  left: 0;
  bottom: env(safe-area-inset-bottom, 0);
  right: 0;
  overflow-x: hidden;
  overflow-y: auto;

  ${(props) =>
    props.fullyOpen &&
    `
   .simplebar-placeholder {
     transition: height 0.3s ease;
   }
  `}

  ${(props) =>
    props.shrinkHeight &&
    `
    margin-top: auto;
    height: min-content;
  `}

  animation: ${(props) => (props.open ? fadeIn : fadeOut)} 0.4s ease-in-out;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalBackground = styled.div<{ open: boolean }>`
  transition: height 0s linear ${(props) => (props.open ? '0s' : '0.4s')};
  height: ${(props) => (props.open ? '100vh' : 0)};

  animation: ${(props) => (props.open ? fadeInOverlay : fadeOutOverlay)} 0.4s ease-in-out;
  background: rgba(0, 0, 0, 0.75);
  width: 100vw;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  position: fixed;
  z-index: -1;
`;

const fadeIn = keyframes`
  0% {
    opacity:0;
    transform: translateY(70px);
  }
  100% {
    opacity:1;
    transform: translateY(0px);
  }
`;

const fadeOut = keyframes`
  0% {
    opacity:1;
    transform: translateY(0px);
  }
  100% {
    opacity:0;
    transform: translateY(70px);
  }
`;

const fadeInOverlay = keyframes`
  0% {
    opacity:0;
  }
  100% {
    opacity:1;
  }
`;

const fadeOutOverlay = keyframes`
  0% {
    opacity:1;
  }
  100% {
    opacity:0;
  }
`;
